import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReportDateRangeService {

  constructor() { }
  private rangeValue: number = 30;
  private rangeUnit: 'days' | 'months' = 'days';

  setMaxRange(value: number, unit: 'days' | 'months' = 'days') {
    this.rangeValue = value;
    this.rangeUnit = unit;
  }

  getMaxRangeValue(): number {
    return this.rangeValue;
  }

  getMaxRangeUnit(): 'days' | 'months' {
    return this.rangeUnit;
  }
}
